export class Publicacion {
  public id: number;
  public titulo: string;
  public subtitulo: string;
  public texto: string;
  public imagen: string;
  public fecha: string;
  public seccion_id: number;
  public destacado: boolean;
  public link: string;

  constructor() { }
}
